define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../shared/dataLogs", "../../utils/kendoUtils", "../../models/UserContext", "../phoneNumbers/phoneNumberActions"], function (require, exports, $, ko, log, urls_1, tools, DataLogs, KendoUtils, UserContext, PhoneNumberActions) {
    "use strict";
    var E911 = /** @class */ (function () {
        function E911() {
            this.canExport = UserContext.hasAccess("Admin,E911.Export");
            this.phoneActions = new PhoneNumberActions();
            this.unassignedDataList = [];
            this.noAddressDataList = [];
            this.filterByAny = ko.observable();
            this.filterNoDefaultByAny = ko.observable();
            this.filterUnassignedByAny = ko.observable();
            this.filterNoAddressByAny = ko.observable();
        }
        E911.prototype.init = function () {
            var self = this;
            tools.ajaxGet({
                url: "/E911/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initAssignedE911Table($.extend(true, {}, self.lookupLists.GridStructures.E911AddressStructure));
                    self.initNoDefaultE911Table($.extend(true, {}, self.lookupLists.GridStructures.E911AddressStructure));
                    self.initUnassignedE911Table($.extend(true, {}, self.lookupLists.GridStructures.E911AddressStructure));
                    self.initNoAddressE911Table($.extend(true, {}, self.lookupLists.GridStructures.E911AddressStructure));
                    setTimeout(function () {
                        self.unassignedE911Table.setDataSource(self.unassignedDataList);
                        self.noAddressE911Table.setDataSource(self.noAddressDataList);
                    });
                    setTimeout(function () {
                        self.getUnassignedE911List();
                    }, 100);
                    self.phoneActions.removeE911Callback = function () {
                        self.cutomersE911Table.refresh();
                        self.noDefaultE911Table.refresh();
                        self.getUnassignedE911List();
                    };
                    self.phoneActions.addE911Callback = function () {
                        self.cutomersE911Table.refresh();
                        self.noDefaultE911Table.refresh();
                        self.getUnassignedE911List();
                    };
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        E911.prototype.initAssignedE911Table = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "50px",
                template: function (dataItem) {
                    var html = "";
                    if (UserContext.hasAccess("Admin,PhoneNumbers.View")) {
                        html += '<a class="btn btn-sm btn-warning btn-view" href="/PhoneNumbers/Details/' + dataItem.PhoneNumberId + '"><i class="fa fa-eye "></i></a>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.cutomersE911Table = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/E911/GetCustomersDefaultE911Addresses",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#e911-toolbar-template").html()),
                    columns: columns,
                    height: 500
                },
                enableExport: {
                    entityName: "E911Details",
                    title: "E911 Addresses",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: true
                },
                gridId: "tblCustomersE911",
                showPagerOnTop: false,
                controller: self
            };
            self.cutomersE911Table.initGrid(gridOptions);
            $("#tblCustomersE911 tbody").on("click", ".numberLogs", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                var dataLogs = new DataLogs("PhoneNumber", data.PhoneNumberId);
                dataLogs.open("Phone number logs: " + data.PhoneNumber);
                event.preventDefault();
            }).on("click", ".numberHistory", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                var dataLogs = new DataLogs("PhoneNumber", data.PhoneNumberId);
                dataLogs.openPhoneNumberHistory(data.PhoneNumber, "Phone number logs: " + data.PhoneNumber);
                event.preventDefault();
            });
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.cutomersE911Table.refresh();
            });
        };
        E911.prototype.initNoDefaultE911Table = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            self.noDefaultE911Table = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/E911/GetNoDefaultE911Addresses",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterNoDefaultByAny()) {
                                    data.filterText = self.filterNoDefaultByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#nodefaulte911-toolbar-template").html()),
                    columns: columns,
                    height: 500
                },
                enableExport: {
                    entityName: "E911Details",
                    title: "E911 Addresses",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: true
                },
                gridId: "tblNoDefaultE911",
                showPagerOnTop: false,
                controller: self
            };
            self.noDefaultE911Table.initGrid(gridOptions);
            $("#tblNoDefaultE911 tbody").on("click", ".numberLogs", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                var dataLogs = new DataLogs("PhoneNumber", data.PhoneNumberId);
                dataLogs.open("Phone number logs: " + data.PhoneNumber);
                event.preventDefault();
            }).on("click", ".numberHistory", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                var dataLogs = new DataLogs("PhoneNumber", data.PhoneNumberId);
                dataLogs.openPhoneNumberHistory(data.PhoneNumber, "Phone number logs: " + data.PhoneNumber);
                event.preventDefault();
            });
            self.filterNoDefaultByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.noDefaultE911Table.refresh();
            });
        };
        E911.prototype.initUnassignedE911Table = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            var column = ko.utils.arrayFirst(columns, function (item) {
                return item.field === "CustomerName";
            });
            var columnIndex = ko.utils.arrayIndexOf(columns, column);
            columns.splice(columnIndex, 1);
            var actions = {
                field: "",
                width: "100px",
                template: function (dataItem) {
                    var html = "";
                    if (UserContext.hasAccess("Admin,PhoneNumbers.Edit,PhoneNumbers.Delete")) {
                        html += '<button class="btn btn-sm btn-info btn-add" title="Add Number" ><i class="fa fa-edit"></i></button>';
                    }
                    if ((UserContext.hasAccess("Admin,PhoneNumbers.Delete,E911.Delete") && !dataItem.HasE911) || (UserContext.hasAccess("Admin,E911.Delete") && dataItem.HasE911)) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" title="Delete"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.unassignedE911Table = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    data: self.unassignedDataList,
                    schema: {
                        model: gridStructure.model
                    },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false
                },
                gridOptions: {
                    toolbar: kendo.template($("#unassignede911-toolbar-template").html()),
                    columns: columns,
                    height: 500
                },
                enableExport: {
                    entityName: "E911Details",
                    title: "E911 Addresses",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: true
                },
                gridId: "tblUnassignedE911",
                showPagerOnTop: false,
                controller: self
            };
            self.unassignedE911Table.initGrid(gridOptions);
            $("#tblUnassignedE911 tbody").on("click", ".numberLogs", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                var dataLogs = new DataLogs("PhoneNumber", data.PhoneNumberId);
                dataLogs.open("Phone number logs: " + data.PhoneNumber);
                event.preventDefault();
            }).on("click", ".numberHistory", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                var dataLogs = new DataLogs("PhoneNumber", data.PhoneNumberId);
                dataLogs.openPhoneNumberHistory(data.PhoneNumber, "Phone number logs: " + data.PhoneNumber);
                event.preventDefault();
            }).on("click", ".btn-add", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.phoneActions.editPhoneNumber(null, data.PhoneNumber);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.phoneActions.removeE911UriConfirm(data.PhoneNumber);
                event.preventDefault();
            });
            self.filterUnassignedByAny.extend({ rateLimit: 200 }).subscribe(function (value) {
                var grid = self.unassignedE911Table.getGridData();
                if (value) {
                    var filter = { logic: "or", filters: [] };
                    filter.filters.push({ field: "PhoneNumber", operator: "contains", value: value });
                    filter.filters.push({ field: "CallerName", operator: "contains", value: value });
                    filter.filters.push({ field: "Address", operator: "contains", value: value });
                    grid.dataSource.filter(filter);
                }
                else {
                    grid.dataSource.filter({});
                }
            });
        };
        E911.prototype.initNoAddressE911Table = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            var actions = {
                field: "",
                width: "50px",
                template: function (dataItem) {
                    var html = "";
                    if ((UserContext.hasAccess("Admin,PhoneNumbers.Delete,E911.Delete") && !dataItem.HasE911) || (UserContext.hasAccess("Admin,E911.Delete") && dataItem.HasE911)) {
                        html += '<button class="btn btn-sm btn-danger btn-remove" title="Delete"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.noAddressE911Table = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    data: self.unassignedDataList,
                    schema: {
                        model: gridStructure.model
                    },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false
                },
                gridOptions: {
                    toolbar: kendo.template($("#noaddresse911-toolbar-template").html()),
                    columns: columns,
                    height: 500
                },
                enableExport: {
                    entityName: "E911Details",
                    title: "E911 Addresses",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: true
                },
                gridId: "tblNoAddressE911",
                showPagerOnTop: false,
                controller: self
            };
            self.noAddressE911Table.initGrid(gridOptions);
            $("#tblNoAddressE911 tbody").on("click", ".numberLogs", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                var dataLogs = new DataLogs("PhoneNumber", data.PhoneNumberId);
                dataLogs.open("Phone number logs: " + data.PhoneNumber);
                event.preventDefault();
            }).on("click", ".numberHistory", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                var dataLogs = new DataLogs("PhoneNumber", data.PhoneNumberId);
                dataLogs.openPhoneNumberHistory(data.PhoneNumber, "Phone number logs: " + data.PhoneNumber);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.phoneActions.removeE911UriConfirm(data.PhoneNumber);
                event.preventDefault();
            });
            self.filterNoAddressByAny.extend({ rateLimit: 200 }).subscribe(function (value) {
                var grid = self.noAddressE911Table.getGridData();
                if (value) {
                    var filter = { logic: "or", filters: [] };
                    filter.filters.push({ field: "PhoneNumber", operator: "contains", value: value });
                    filter.filters.push({ field: "CallerName", operator: "contains", value: value });
                    filter.filters.push({ field: "Address", operator: "contains", value: value });
                    grid.dataSource.filter(filter);
                }
                else {
                    grid.dataSource.filter({});
                }
            });
        };
        E911.prototype.getUnassignedE911List = function () {
            var self = this;
            self.unassignedE911Table.showLoading(true);
            self.noAddressE911Table.showLoading(true);
            tools.ajaxPost({
                url: "/E911/GetUnassignedE911Addresses",
                success: function (data) {
                    if (data.Success) {
                        self.unassignedDataList = ko.utils.arrayFilter(data.Data, function (item) {
                            return !item.Assigned && item.Address;
                        });
                        self.noAddressDataList = ko.utils.arrayFilter(data.Data, function (item) {
                            return !item.Address;
                        });
                        self.unassignedE911Table.setDataSource(self.unassignedDataList);
                        self.noAddressE911Table.setDataSource(self.noAddressDataList);
                        self.unassignedE911Table.showLoading(false);
                        self.noAddressE911Table.showLoading(false);
                    }
                }
            });
        };
        E911.prototype.addNewE911 = function () {
            var self = this;
            self.phoneActions.addE911Details();
        };
        E911.prototype.updateE911DetailsConfirm = function () {
            var self = this;
            tools.confirmModal({
                title: "Update All E911 Details",
                text: "Are you sure you want to Update All E911 Details?",
                buttonTitle: "Update",
                type: "info",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.updateE911Details();
            });
        };
        E911.prototype.updateE911Details = function () {
            var self = this;
            var btn1 = $("#updateE911FromApi").button("loading");
            tools.ajaxPost({
                url: "/E911/UpdateAllAddressDetails"
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.cutomersE911Table.refresh();
                    self.noDefaultE911Table.refresh();
                    self.getUnassignedE911List();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                btn1.button("reset");
            });
        };
        E911.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        E911.prototype.exportTo = function () {
            var self = this;
            if (self.canExport) {
                self.cutomersE911Table.exportTo();
            }
        };
        E911.prototype.clearNoDefaultFilter = function () {
            var self = this;
            self.filterNoDefaultByAny("");
        };
        E911.prototype.exportToNoDefault = function () {
            var self = this;
            if (self.canExport) {
                self.noDefaultE911Table.exportTo();
            }
        };
        E911.prototype.clearUnassignedFilter = function () {
            var self = this;
            self.filterUnassignedByAny("");
        };
        E911.prototype.exportToUnassigned = function () {
            var self = this;
            if (self.canExport) {
                self.unassignedE911Table.exportTo();
            }
        };
        E911.prototype.clearNoAddressFilter = function () {
            var self = this;
            self.filterNoAddressByAny("");
        };
        E911.prototype.exportToNoAddress = function () {
            var self = this;
            if (self.canExport) {
                self.noAddressE911Table.exportTo();
            }
        };
        return E911;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/E911/Index")) {
            log.log("Initialize E911 list");
            $(function () {
                (new E911()).init();
            });
        }
    }, 0);
    return E911;
});
//# sourceMappingURL=e911.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/e911/e911.js
// module id = 214
// module chunks = 2